/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Menu paper: the popup used by Select and by every action menu.
 * Outlined surface on a mid shadow, 6px inset so items keep their own radius.
 */

import boxShadows from "assets/theme/base/boxShadows";
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { md } = boxShadows;
const { size } = typography;
const { text, outline, background } = colors;
const { borderRadius } = borders;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: {
      minWidth: pxToRem(160),
      padding: pxToRem(6),
      marginTop: pxToRem(4),
      borderRadius: borderRadius.md,
      border: `1px solid ${outline.variant}`,
      boxShadow: md,
      backgroundColor: background.paper,
      color: text.main,
      fontSize: size.sm,
      textAlign: "left",
    },
    list: {
      padding: 0,
    },
  },
};

export default menu;
